import { produce } from 'immer';
import { StateCreatorWithDevtools } from '../store-utils';
import { SeenCreditCardCondition } from '../../logic/models';
import { PriceGroupModel } from '../../mvcapi/models/buyticket';

// INFO: New sale

export interface CreditCardConditionSeenStoreSlice {
    /** List of the credit card condition that a user has seen */
    creditCardConditionsSeen: SeenCreditCardCondition,
    /** Set/reset the whole state */
    setCreditCardConditionsSeen: (creditCardConditionsSeen: SeenCreditCardCondition) => void,

    /** Set as seen by ID */
    setCreditCardConditionAsSeen: (creditCardConditionsId: string) => void,
    
    /** Set as seen by MVCAPI/PriceGroupModel */
    setCreditCartConditionsAsSeen: (priceGroup: PriceGroupModel[]) => void,
}

export const CreditCardConditionSeenStoreSliceDef: StateCreatorWithDevtools<CreditCardConditionSeenStoreSlice, CreditCardConditionSeenStoreSlice> = (set, get) => {
    return {

        creditCardConditionsSeen: {},
        setCreditCardConditionsSeen: (creditCardConditionsSeen: SeenCreditCardCondition) => set({ creditCardConditionsSeen }, false, "creditCardConditionsSeen"),

        setCreditCardConditionAsSeen: (creditCardConditionsId: string) => { 
            set(produce(d => { 
                d.creditCardConditionsSeen[creditCardConditionsId] = true;
            }), false, { type: "setCreditCardConditionAsSeen", creditCardConditionsId });
        },

        setCreditCartConditionsAsSeen: (priceGroups: PriceGroupModel[]) => {
            if(!priceGroups) return;
            priceGroups.forEach(pg => {
                if (pg.RequiresCreditCardCondition && !get().creditCardConditionsSeen[pg.RequiredCreditCardConditionID]) {
                    get().setCreditCardConditionAsSeen(pg.RequiredCreditCardConditionID);
                }
            });
        },
    };
};

